<template>
  <permission-guard situation="site_configuration">
    <v-alert dense outlined type="error" style="width: 400px">
      <span class="caption">
        削除を実施すると、このサイトに保存されているキャッシュを全て消去します。
        <a href="https://support.b-cms.jp/60" target="_blank" style="color: #ff5252; text-decoration:underline; text-decoration-color:#FF0000; border-width:2px;">キャッシュ削除とは</a>
      </span>
    </v-alert>
    <v-btn color="green darken-1" tile dark depressed @click="cacheDeletion">
      削除
    </v-btn>
  </permission-guard>
</template>

<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'

export default {
  components: {
    PermissionGuard
  },
  methods: {
    cacheDeletion () {
      if (!confirm('キャッシュを削除しますか？')) return true

      axios.delete(`/api/sites/cache_deletions`).then(
        () => {
          const payload = {
            status: 200,
            message: 'キャッシュを削除しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors
              ? error.response.data.errors.toString()
              : '空白です'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>

<style></style>
